import {Close, Warning} from '@mui/icons-material'
import {Alert, AlertTitle, Box, IconButton} from '@mui/material'
import React from 'react'

import {LayoutConstants, useUikitTranslation} from '../../common'

type Props = {
  onClose: () => void
}

export const UnsupportedBrowserWarning: React.FC<Props> = ({onClose}) => {
  const {t} = useUikitTranslation()

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        width: '100%',
        height: 120,
        maxWidth: LayoutConstants.DEFAULT_CONTENT_WIDTH,
        marginLeft: 'auto',
        marginRight: 'auto'
      }}
    >
      <Alert
        sx={{
          width: '100%',
          whiteSpace: 'pre-line'
        }}
        severity="warning"
        icon={
          <Warning
            fontSize="large"
            sx={{
              alignSelf: 'center'
            }}
          />
        }
        action={
          <IconButton color="inherit" size="small" onClick={() => onClose()} aria-label="close">
            <Close fontSize="inherit" />
          </IconButton>
        }
      >
        <AlertTitle>{t('unsupportedBrowser.title')}</AlertTitle>
        <span style={{display: 'block'}}>{t('unsupportedBrowser.message')}</span>
        <span style={{display: 'block'}}>{t('unsupportedBrowser.hint')}</span>
      </Alert>
    </Box>
  )
}
